<template>
  <section v-lenis-scroll class="horizontal-grid">
    <div class="horizontal-grid-wrapper">
      <div v-for="(value, key) in shopifyData.productData" :key="key" class="grid_item">
        <a
          :href="value.showCollection == 'true' ? value.collectionLink : value.product.productUrl"
          :product-id="value.showCollection == 'true' ? null : value.product.productid"
          class="product_link"
        >
          <div class="tharProductInfo" :class="value.showPreview === 'true' ? 'customImage' : ''">
            <h1 class="tharProductTitle">{{ value.product.productTitle || 'Product Title' }}</h1>
            <div class="tharProductPriceInfo">
              <span
                v-if="
                  value.product.compare_at_price >
                  (value.showCollection == 'true' ? value.product.productidPrice : '1')
                "
                class="tharProductPrice"
              >
                <del>{{ currencySymbol }} {{ value.product.compare_at_price }}</del>
              </span>
              <span v-if="value.product.productidPrice" class="tharProductPrice">
                {{ currencySymbol }} {{ value.product.productidPrice }}
              </span>
              <span
                v-if="
                  value.product.compare_at_price >
                  (value.showCollection == 'true' ? value.product.productidPrice : '1')
                "
                class="discountPercentage tharProductPrice"
              >
                {{ value.product.discount_percentage }}
              </span>
            </div>
          </div>
          <div class="grid_item_img">
            <img
              v-lazy="
                value.showPreview == 'true' ? value.previewimage : value.product.productidImage
              "
              :alt="value.showPreview === 'true' ? 'Preview Image' : value.product.productTitle"
              loading="lazy"
              aria-hidden="true"
              aria-label="Product Image"
              width=""
              height=""
            />
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import { currencyJson } from '@/currency';
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currencySymbol() {
      return currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
    },
  },
};
</script>

<style scoped>
.horizontal-grid-wrapper {
  background-color: #eeeff2;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.horizontal-grid-wrapper .grid_item {
  position: relative;
}

.tharProductTitle,
.tharProductPrice {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 12.08px;
  font-weight: 400;
  line-height: 10.99px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #000;
}

.tharProductPriceInfo {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.discountPercentage {
  color: red;
}

.tharProductPrice {
  font-weight: 700;
}

.tharProductInfo.customImage * {
  color: #fff;
}

.tharProductInfo.customImage .discountPercentage {
  color: red;
}

.tharProductInfo.customImage del {
  color: grey;
}

.grid_item_img img {
  width: 100%;
  display: block;
}

.grid_item .tharProductInfo {
  position: absolute;
  bottom: 12px;
  left: 10px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

@media screen and (max-width: 991px) {
  .horizontal-grid-wrapper {
    grid-template-columns: 1fr 1fr;
  }

  .grid_item:nth-child(4) {
    grid-area: 2 / 1 / 3 / 2;
  }

  .grid_item:nth-child(5) {
    grid-area: 3 / 2 / 4 / 3;
  }

  .grid_item:nth-child(7) {
    grid-area: 4 / 1 / 5 / 2;
  }
}

@media screen and (max-width: 768px) {
  .tharProductTitle,
  .tharProductPrice {
    font-size: 8px;
    line-height: 1;
  }

  .grid_item .tharProductInfo {
    bottom: 2px;
    left: 2px;
    padding: 5px;
  }
}
</style>
